import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Participation_Messages } from 'src/app/common-class/survey-messages';
import { } from 'events';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { CommonSetting } from 'src/app/common-class/survey';
declare var $ : any;


@Component({
  selector: 'app-survey-messages',
  templateUrl: './survey-messages.component.html',
  styleUrls: ['./survey-messages.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyMessagesComponent implements OnInit {

  @Input() participation_Messages: Participation_Messages;
  @Input() participation_Message_Type: number;
  @Input() isSurveyExpired: boolean;
  @Input() isSubscriptionModel: boolean;
  @Input() isMobile: boolean;
  @Input() isTablet: boolean;
  @Input() PoweredByText: string;
  @Input() isPreview :boolean;
  @Input() isAssessment:boolean;
  @Input() ProductName:string;
  @Input() SupportEmail:string;
  @Input() isPowredByClient : boolean
  @Input() SurveyLogoImageUrl:string;
  @Input() SurveyLogoAlign: number;
  @Input() SurveyURL:string;
  @Input() Title:string;
  @Output() partialResponceHandling: EventEmitter<any> = new EventEmitter();
  @Output() EditResponceHandling : EventEmitter<any> = new EventEmitter();


  constructor(private service:ParticipationDataService,private commonSetting: CommonSetting) { }

  isPartialAccessHide : boolean;
  isPartialAccessDoneHide : boolean;
  email_id:string;
  unique_url:string;
  isRTL:boolean;
  surveyType:string;
  isEmbedMobile: boolean;
  isEmailValid: boolean = false;
  path: string = "";
  isCookieEnable: boolean;
  cookieSupportLinks: any;
  isIE: boolean = false;
  isSafari:boolean = false;
  islinkemail: boolean = false;
  isTechCheck:boolean = false;


  ngOnInit() {
   this.isPartialAccessHide = true;
   this.isPartialAccessDoneHide = false;
    if (this.participation_Messages.partial_and_quota_message != null &&
      this.participation_Messages.partial_and_quota_message != undefined &&
      this.participation_Messages.partial_and_quota_message.unique_url != null &&
      this.participation_Messages.partial_and_quota_message.unique_url != undefined) {
      this.unique_url = this.participation_Messages.partial_and_quota_message.unique_url.replace("/k", "/k1");
    }
    this.isRTL = this.service.isRTL;
    this.surveyType = this.isAssessment ?"Assessment":"Survey";

    if(this.commonSetting.isEmbedMobile == 1){
      this.isEmbedMobile = true;
    }
    this.path = this.service.getBasePath() +"/"+ this.service.getImageFolder();

    if(this.participation_Message_Type == 4)
    {
      let browserCookieStatus  = navigator.cookieEnabled;
      var msie = navigator.userAgent.indexOf("MSIE ");
      this.isSafari = navigator.userAgent.includes('Safari') && navigator.userAgent.includes('Apple') &&  /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);;
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
      {
        this.isIE=true;
      }
      else {
        if(browserCookieStatus != undefined && browserCookieStatus)
        {
            this.isCookieEnable = true;
            this.SurveyURL = this.SurveyURL.replace("&isEmbedMobile=1","");
        }
        else
        {
          this.isCookieEnable = false;
        }
      }

      if((this.isCookieEnable && this.isSafari) || (this.isEmbedMobile && this.isIE))
      {
        this.isTechCheck = true;
      }

    }

    this.setBrowserCookieLinks();
  }

  ngAfterViewInit() {
    if($('.mobile-wrapper').length == 0){
      this.setMessage();
    }

    var self = this;
    if(self.participation_Messages.partial_and_quota_message && self.participation_Messages.partial_and_quota_message.unique_url)
    {
      let CopyWidth =$(".url-info").outerWidth();
      $('.send-email-text').width(CopyWidth - 28);
    }

    // this.bottomfooterPos();
    setTimeout(() => {
      $('body').getNiceScroll().resize();
    }, 100);

    $(document).ready(function() {
      setTimeout(() => {
        $(".ap_accordion_msg").find("span").click(function(){
          if($(this).hasClass("checkData")){
               $(this).removeClass("checkData");
          }else{
           $(".checkData").removeClass("checkData");
               $(this).addClass("checkData");
          }
       });
      }, 10);

    });
    if(this.participation_Messages.addAddNoContent)
    {
      $(document).ready(function() {
        $("head").append("<meta name='robots' content='noindex, nofollow, noarchive'/> ");
      });
    }
    if (self.participation_Message_Type == 51 && $(".SurveyMsgWrapper .ap_accordion_msg").length == 0) {
      $('.SurveyMsgWrapper').addClass('Notaccordion_surveyMsg');
    }
  }


  BeginNewResponse(event: any) {
    this.partialResponceHandling.emit(event);
  }
  BeginNewResponseRef(event: any) {
    this.partialResponceHandling.emit(event);
  }
  BrowserContinue(event:any)
  {
    this.partialResponceHandling.emit(event);
  }
  LastLeftResponse(event: any) {
    this.partialResponceHandling.emit(event);
  }
  SurveyEdiited(event:any){
    this.partialResponceHandling.emit(event);
  }

  linkemail(event: any) {
    if (this.participation_Messages.partial_and_quota_message.isQuota) {
      this.EditResponceHandling.emit(event);
    }else{
      if(this.email_id == "" || this.email_id == null){
        alert('Please enter Email Address.');
      }
      else if (this.isEmailValid) {
        alert('Invalid Email Address!');
      } else {
        let arrPartiallyDone: Array<string> = [];

        arrPartiallyDone[0] = "true";
        arrPartiallyDone[1] = this.email_id;
        arrPartiallyDone[2] = "send";


        this.EditResponceHandling.emit(arrPartiallyDone);
        this.islinkemail = true
      }
    }
  }

  goBackQuota(event: any) {
    if (this.isEmailValid) {
      alert('Invalid Email Address!');
    } else {
      if (this.participation_Messages.partial_and_quota_message.isQuota) {
        this.EditResponceHandling.emit(event);
      }
      else
      {
        let arrPartiallyDone: Array<string> = [];

        arrPartiallyDone[0] = "true";
        arrPartiallyDone[1] = this.email_id;
        arrPartiallyDone[2] = "done";

        this.EditResponceHandling.emit(arrPartiallyDone);
        this.isPartialAccessHide = false;
        this.isPartialAccessDoneHide = true;
      }
    }
  }

//    bottomfooterPos() {

//     var docHeight = $(window).height();

//     var footerHeight = $('.footer-div').height();

//     var footerTop = $('.footer-div').position().top + footerHeight;

//     if (footerTop < docHeight) {

//      $('.footer-div').css('margin-top', (docHeight - footerTop)-135 + 'px');

//     }

//  }

  setMessage(){
   


    if($('.SurveyMsgWrapper').hasClass('browser-message-width')){
      $('.SurveyMsgWrapper').css('width', '80%');
      $('.SurveyMsgWrapper').css('max-width', '80%');
    }
    // if(this.isTablet){
    //   $('.SurveyMsgWrapper').css('width', '85%');
    //   $('.SurveyMsgWrapper').css('max-width', '85%');
    // }
    if(this.isMobile){
      $('.SurveyMsgWrapper').css('width', '99%');
      $('.SurveyMsgWrapper').css('max-width', '99%');

      if($('.SurveyMsgWrapper').outerHeight() < $(window).height()){
        $('.SurveyMsgWrapper').css({
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '75%',
          maxWidth: '75%'
        });
      } else {
        $('.SurveyMsgWrapper').css({
          position: 'relative',
          top: '0',
          left: '0',
          transform: 'translate(0, 0)',
          width: '75%',
          maxWidth: '75%'
        });
      }
    }
  }

  emailValidation(curVal: string) {

    if (curVal == "" || curVal == null) {
      this.isEmailValid = false;
      return;
    } else {
      const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
      //new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

      let isValid = regexp.test(curVal);

      if (!isValid) {
        this.isEmailValid = true;
        alert('Invalid Email Address!');
      } else {
        this.isEmailValid = false;
      }
    }
  }

  setBrowserCookieLinks() {
    if (this.isMobile || this.isTablet) {
      this.cookieSupportLinks = {
        safari: "https://support.apple.com/en-in/HT201265",
        chrome: "https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DAndroid&hl=en&oco=1",
        firefox: "https://support.mozilla.org/en-US/kb/enable-or-disable-cookies-firefox-android",
        edge: "https://answers.microsoft.com/en-us/windows/forum/apps_windows_10-msedge/edge-how-do-i-enable-cookies/275b58e3-d741-4b21-8042-3059b1902d0e"
      };
    } else {
      this.cookieSupportLinks = {
        safari: "https://support.apple.com/en-in/guide/safari/sfri11471/mac",
        chrome: "https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en&oco=1",
        firefox: "https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them",
        edge: "https://answers.microsoft.com/en-us/windows/forum/apps_windows_10-msedge/edge-how-do-i-enable-cookies/275b58e3-d741-4b21-8042-3059b1902d0e",
        ie: "https://support.microsoft.com/en-in/help/17442/windows-internet-explorer-delete-manage-cookies"
      };
    }
  }

  copyToClipboard() {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(this.participation_Messages?.partial_and_quota_message.unique_url1).select();
    document.execCommand("copy");
    $temp.remove();
}
}
